import { useMutation } from 'react-query'
import { get } from 'framework/api/http'

export const useGetDistinctCourrierList = () => {
  return useMutation(() => get(`/AllCarriers`)) // ✅ No need for data parameter
}

export default useGetDistinctCourrierList
